<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <!-- search condition start -->
    <el-row>
      <selectStandardId @updateStandardId="updateStandardId" />
      <el-select
        filterable
        clearable
        size="small"
        v-model="searchCondition.class_id"
        @change="changeClass"
        placeholder="请选择实体"
        class="w-200px mr-10px ml-10px"
      >
        <el-option
          v-for="item in classLists"
          :key="item.id"
          :value="item.value"
          :label="item.label"
        ></el-option>
      </el-select>
      <el-select
        filterable
        clearable
        size="small"
        v-model="searchCondition.attribute_id"
        placeholder="请选择属性"
        class="w-200px mr-10px"
      >
        <el-option
          v-for="item in attrLists"
          :key="item.id"
          :value="item.value"
          :label="item.label"
        ></el-option>
      </el-select>
      <el-button type="primary" @click="searchTableData">{{ $t('search') }}</el-button>
      <el-button :disabled="!$hasAccess('create')" type="primary" @click="handleEdit('create')">{{
        $t('create')
      }}</el-button>
    </el-row>
    <!-- search condition end -->
    <!-- table start -->
    <el-table
      :data="tableData"
      border
      height="calc(100% - 106px)"
      v-loading="tableLoading"
      class="mt-20px"
    >
      <el-table-column :label="$t('标准')" prop="standardName"></el-table-column>
      <el-table-column :label="$t('实体')" prop="className"></el-table-column>
      <el-table-column :label="$t('属性')" prop="attributeName"></el-table-column>
      <el-table-column :label="$t('业务操作')" prop="businessOperationName"></el-table-column>
      <el-table-column :label="$t('呈现方式')" prop="presentationTypeStr"></el-table-column>
      <el-table-column :label="$t('参数属性')" prop="parameterValues"></el-table-column>
      <el-table-column :label="$t('操作')" width="200">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleRow(scope.row, 'read')"
            :disabled="!$hasAccess('read')"
            >{{ $t('view') }}</el-button
          >
          <el-button
            :disabled="!$hasAccess('update')"
            size="mini"
            @click="handleRow(scope.row, 'edit')"
            >{{ $t('edit') }}</el-button
          >
          <el-button :disabled="!$hasAccess('delete')" size="mini" @click="deleteRow(scope.row)">{{
            $t('delete')
          }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- table end -->
    <!-- pagigation start -->
    <el-pagination
      class="mt-20px float-right"
      background
      @size-change="searchTableData()"
      @current-change="findTableData()"
      :current-page.sync="page.pageNo"
      :page-sizes="$pageSizeAll"
      :page-size.sync="page.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="page.pageTotal"
    ></el-pagination>
    <!-- pagigation end -->
    <!-- 新增、编辑业务操作 start -->
    <el-dialog :title="dialogTitle" width="1000px" :visible.sync="dialogVisible" v-dialogDrag>
      <el-form
        :disabled="currentEditType === 'read'"
        ref="operationsManagementForm"
        :model="operationsManagementForm"
        :rules="operationsManagementFormRules"
        label-width="150px"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$t('标准')" prop="standardId">
              <el-select
                filterable
                clearable
                class="w-full"
                size="small"
                v-model="operationsManagementForm.standardId"
                @change="changeFormStandard"
              >
                <el-option
                  v-for="item in standardLists"
                  :key="item.id"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('实体')" prop="classId">
              <el-select
                filterable
                clearable
                class="w-full"
                size="small"
                v-model="operationsManagementForm.classId"
                @change="changeFormClass"
              >
                <el-option
                  v-for="item in formClassLists"
                  :key="item.id"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('属性')" prop="attributeId">
              <el-select
                filterable
                clearable
                size="small"
                class="w-full"
                v-model="operationsManagementForm.attributeId"
              >
                <el-option
                  v-for="item in formAttrLists"
                  :key="item.id"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('业务操作')" prop="businessOperationId">
              <el-select
                size="small"
                filterable
                @change="changeBusinessOperate"
                clearable
                v-model="operationsManagementForm.businessOperationId"
                class="w-full"
              >
                <el-option
                  v-for="item in businessOperation"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('呈现方式')" prop="presentationType">
              <el-select
                size="small"
                filterable
                clearable
                v-model="operationsManagementForm.presentationType"
                class="w-full"
              >
                <el-option
                  v-for="item in presentationTypes"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('按钮名或提示')" prop="buttonName">
              <el-input size="small" v-model="operationsManagementForm.buttonName" />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-for="item in currentParamLists" :key="item.id">
            <el-form-item :label="item.name">
              <el-radio-group v-model="item.parameterType">
                <el-radio v-for="item in parameterTypes" :key="item.value" :label="item.value">
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
              <el-input size="small" v-if="item.parameterType === 0" v-model="item.fixedValue" />
              <el-select
                v-else
                filterable
                clearable
                size="small"
                class="w-full"
                v-model="item.attributeId"
              >
                <el-option
                  v-for="item in formAttrLists"
                  :key="item.id"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="tc" v-if="currentEditType !== 'read'">
        <el-button type="primary" size="small" class="iconfont icon-save" @click="save()">{{
          $t('save')
        }}</el-button>
        <el-button size="small" class="iconfont icon-close" @click="dialogVisible = false">{{
          $t('cancel')
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增、编辑业务操作 end -->
  </el-card>
</template>
<script>
import StdAttrBusinessOperation from '@/services/bsApi/StdAttributeBusinessOperation'
import StdBusinessOperation from '@/services/bsApi/StdBusinessOperation'
import CommonService from '@/services/assetService'
import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'operationsManagement',
  components: { selectStandardId },
  data() {
    return {
      parameterTypes: [],
      classLists: [],
      attrLists: [],
      formClassLists: [],
      formAttrLists: [],
      presentationTypes: [],
      businessOperation: [],
      paramsLists: [],
      dialogVisible: false,
      dialogTitle: '新增属性业务操作',
      tableLoading: false,
      searchCondition: {
        standard_id: localStorage.getItem('standardId'),
        class_id: '',
        attribute_id: '',
      },
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      operationsManagementFormRules: {
        standardId: [
          {
            required: 'true',
            message: '请选择标准',
            trigger: 'blur',
          },
        ],
        classId: [
          {
            required: 'true',
            message: '请选择实体',
            trigger: 'blur',
          },
        ],
        attributeId: [
          {
            required: 'true',
            message: '请选择属性',
            trigger: 'blur',
          },
        ],
        businessOperationId: [
          {
            required: 'true',
            message: '请选择业务操作',
            trigger: 'blur',
          },
        ],
        presentationType: [
          {
            required: 'true',
            message: '请选择呈现方式',
            trigger: 'blur',
          },
        ],
        buttonName: [
          {
            required: 'true',
            message: '请输入按钮名或提示',
            trigger: 'blur',
          },
        ],
      },
      operationsManagementForm: {
        standardId: '',
        classId: '',
        attributeId: '',
        businessOperationId: '',
        presentationType: '',
        buttonName: '',
      },
      openTypes: [],
      operationCategory: [],
      currentEditType: 'create',
      currentParamLists: [],
      standardLists: [],
    }
  },
  watch: {
    dialogVisible(bol) {
      if (!bol) {
        this.operationsManagementForm = this.$options.data().operationsManagementForm
        this.currentParamLists = []
      }
    },
    'searchCondition.standard_id': {
      handler(newVal) {
        if (newVal) {
          this.classLists = []
          this.attrLists = []
          this.searchCondition.class_id = ''
          this.searchCondition.attribute_id = ''
          this.findClass(newVal, 'classLists')
          this.searchTableData()
        }
      },
    },
  },
  methods: {
    updateStandardId(val) {
      this.searchCondition.standard_id = val
    },
    async getParameterType() {
      const res = await StdAttrBusinessOperation.getParameterType()
      if (res && res.code === 0 && res.data) {
        _.forIn(res.data, (value, key) => {
          this.parameterTypes.push({
            label: value,
            value: _.toNumber(key),
          })
        })
      }
    },
    changeBusinessOperate(id) {
      const currentRow = _.find(this.businessOperation, ['id', id])
      this.currentParamLists = currentRow ? currentRow.parameterList : []
      _.forEach(this.currentParamLists, (item) => {
        this.$set(item, 'parameterType', 0)
        this.$set(item, 'fixedValue', '')
        item.businessOperationParameterId = item.id
        delete item.createdTime
        delete item.lastModifiedTime
        delete item.attributeId
      })
    },
    async findBusinessOperate() {
      const res = await StdBusinessOperation.find({
        pageNo: 1,
        pageSize: 999,
        code: '',
        name: '',
      })
      if (res && res.code === 0 && res.data) {
        this.businessOperation = res.data
      }
    },
    async getPresentationType() {
      const res = await StdAttrBusinessOperation.getPresentationType()
      if (res && res.code === 0 && res.data) {
        _.forIn(res.data, (value, key) => {
          this.presentationTypes.push({
            label: value,
            id: _.toNumber(key),
          })
        })
      }
    },
    async findStandardLists() {
      const res = await CommonService.getStdStandardList()
      if (res && res.code === 0 && res.data) {
        this.standardLists = _.map(res.data, (item) => {
          return {
            label: item.name,
            value: item.id,
          }
        })
      }
    },
    changeFormStandard(id) {
      this.operationsManagementForm = {
        standardId: id,
        classId: '',
        attributeId: '',
        businessOperationId: '',
        presentationType: '',
        buttonName: '',
      }
      this.findClass(id, 'formClassLists')
    },
    async findClass(standardId, type) {
      const res = await CommonService.getClassList({
        standardId,
      })
      if (res && res.code === 0 && res.data) {
        this[type] = _.map(res.data, (item) => {
          return {
            label: item.name,
            value: item.id,
          }
        })
      }
    },
    changeClass(id) {
      this.searchCondition.attribute_id = ''
      this.attrLists = []
      this.findAttr(id, 'attrLists')
    },
    changeFormClass(id) {
      this.operationsManagementForm.attributeId = ''
      this.currentParamLists = []
      this.findAttr(id, 'formAttrLists')
    },
    async findAttr(classId, type) {
      const res = await CommonService.getOpenAtrrOptions({
        classId,
      })
      if (res && res.code === 0 && res.data) {
        this[type] = _.map(res.data, (item) => {
          return {
            label: item.name,
            value: item.id,
          }
        })
      }
    },
    async handleRow(row, type) {
      this.currentEditType = type
      this.dialogTitle = type === 'edit' ? '编辑属性业务操作' : '查看属性业务操作'
      this.$nextTick(() => {
        this.$refs.operationsManagementForm.resetFields()
      })
      const res = await StdAttrBusinessOperation.find({
        id: row.id,
      })
      if (res && res.code === 0 && res.data) {
        this.operationsManagementForm = res.data
        this.dialogVisible = true
        this.currentParamLists = res.data.parameterList
        _.forEach(this.currentParamLists, (item) => {
          item.name = item.businessOperationParameterName
          delete item.createdTime
          delete item.lastModifiedTime
        })
        this.findClass(this.operationsManagementForm.standardId, 'formClassLists')
        this.findAttr(this.operationsManagementForm.classId, 'formAttrLists')
      }
    },
    deleteRow(row) {
      this.$confirm('是否确定要删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await StdAttrBusinessOperation.remove({
          data: [row.id],
        })
        if (res && res.code === 0) {
          this.$message.success('删除成功')
          if (this.tableData.length === 1 && this.page.pageNo > 1) {
            this.page.pageNo -= 1
          }
          this.findTableData()
        }
      })
    },
    save() {
      this.$refs.operationsManagementForm.validate(async (valid) => {
        if (valid) {
          const reqData = _.cloneDeep(this.operationsManagementForm)
          reqData.parameterList = _.cloneDeep(this.currentParamLists)
          _.forEach(reqData.parameterList, (item) => {
            delete item.id
          })
          let validate = true
          _.forEach(this.currentParamLists, (item) => {
            if (!item.fixedValue && !item.attributeId) {
              validate = false
            }
          })
          if (!validate) {
            this.$message.warning('请补充完属性值')
            return
          }
          let res
          if (this.currentEditType === 'edit') {
            delete reqData.createdTime
            delete reqData.lastModifiedTime
            res = await StdAttrBusinessOperation.update({
              model: reqData,
            })
          } else {
            res = await StdAttrBusinessOperation.save({
              model: reqData,
            })
          }
          if (res && res.code === 0) {
            const text = this.currentEditType === 'create' ? '新增' : '修改'
            this.$message.success(`${text}成功`)
            this.dialogVisible = false
            this.findTableData()
          }
        }
      })
    },
    handleEdit(type) {
      this.currentEditType = type
      this.dialogVisible = true
      this.dialogTitle = '新增属性业务操作'
      this.$nextTick(() => {
        this.$refs.operationsManagementForm.resetFields()
      })
      this.formClassLists = []
      this.formAttrLists = []
      this.operationsManagementForm.standardId = this.searchCondition.standard_id
      this.findClass(this.searchCondition.standard_id, 'formClassLists')
    },
    searchTableData() {
      this.page.pageNo = 1
      this.findTableData()
    },
    async findTableData() {
      const reqData = {
        pageno: this.page.pageNo,
        pagesize: this.page.pageSize,
        ...this.searchCondition,
      }
      this.tableLoading = true
      const res = await StdAttrBusinessOperation.find(reqData)
      this.tableLoading = false
      if (res && res.code === 0 && res.data) {
        this.tableData = res.data
        this.page.pageTotal = res.page.recordCount
        _.forEach(this.tableData, (item) => {
          item.state = item.state === 0 // 0 启用 1 停用
        })
      }
    },
  },
  async created() {
    this.findStandardLists()
    this.getPresentationType()
    this.findBusinessOperate()
    this.getParameterType() // 获取参数类型
    if (this.searchCondition.standard_id) {
      this.searchTableData()
      this.findClass(this.searchCondition.standard_id, 'classLists') // 获取实体下拉列表
    }
  },
  activated() {
    this.searchCondition.standard_id = localStorage.getItem('standardId')
  },
}
</script>
<style lang="scss" scoped>

/deep/.el-input-group__append {
  /deep/.el-button {
    background: #46a6ff !important;
    color: #fff !important;
  }
}

</style>
